const CARD_SELECTOR = '.logo-box__one';
const MEDIA_SELECTOR = '.logo-box__one-media';
const DESCRIPTION_SELECTOR = '.logo-box__one-description';

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const getTranslatePercent = (descriptionHeight, cardHeight) => {
  if (!descriptionHeight || !cardHeight) {
    return 0.33;
  }

  const relative = descriptionHeight / cardHeight;
  const scaled = relative * 1.2;

  return clamp(scaled, 0.25, 0.45);
};

const setTranslateFromDescription = (media, description, card) => {
  const height = description.scrollHeight;
  const cardHeight = card.getBoundingClientRect().height;

  if (!height || !cardHeight) {
    return;
  }

  const percent = getTranslatePercent(height, cardHeight);

  media.style.setProperty('--description-translate', `-${percent * 100}%`);
};

const resetTranslate = (media) => {
  media.style.removeProperty('--description-translate');
};

const attachHandlers = (card) => {
  const media = card.querySelector(MEDIA_SELECTOR);
  const description = card.querySelector(DESCRIPTION_SELECTOR);

  if (!media || !description) {
    return;
  }

  const handleShow = () => setTranslateFromDescription(media, description, card);
  const handleHide = () => resetTranslate(media);

  card.addEventListener('pointerenter', handleShow);
  card.addEventListener('pointerleave', handleHide);
  card.addEventListener('focusin', handleShow);
  card.addEventListener('focusout', handleHide);
};

export default function logoBox() {
  if (typeof document === 'undefined') {
    return;
  }

  const cards = document.querySelectorAll(CARD_SELECTOR);

  if (!cards.length) {
    return;
  }

  cards.forEach(attachHandlers);
}

logoBox();
